export function isFuturePost(date: Date | undefined) {
  const isInFuture = new Date() <= new Date(date ?? "");
  return Boolean(isInFuture);
}
